import React from 'react'
import WorkspaceComp from './WorkspaceComp'

function Workspace() {
  return (
    <div className='workspacePage'>
      <WorkspaceComp/>
    </div>
  )
}

export default Workspace
